export const Status = {
	DRAFT: "DRAFT",
	LIVE: "LIVE",
	ARCHIVED: "ARCHIVED",
	DELETED: "DELETED"
} as const;

export type StatusType = (typeof Status)[keyof typeof Status];

export type Update = {
	status: StatusType;
};
